import { Link } from "@remix-run/react";
import { format } from "date-fns";
import { ChevronRight } from "react-feather";
import type { TravelPost } from "../data/travelPosts";
import { isNotEmpty } from "../lib/utils";
import { WorldMap } from "./WorldMap";

// TODO: This whole component is a bit funky. Should it be split out?
export function TravelHeader({
	countrySlug,
	townSlug,
	posts,
}: {
	countrySlug: string | null;
	townSlug: string | null;
	posts: TravelPost[]; // TODO: This is weird. Don't pass this. Make interface something that makes sense, not passing an array of posts
}) {
	const relevantPost = posts.find((post) => {
		if (townSlug && post.townSlug !== townSlug) return false;
		if (countrySlug && post.countrySlug !== countrySlug) return false;

		return true;
	});

	const items: { path: string; title: string }[] = [
		{
			path: "/",
			title: "Home",
		},
		{
			path: "/travel",
			title: "Travel Blog",
		},
		countrySlug &&
			relevantPost && {
				path: `/travel/${countrySlug}`,
				title: relevantPost.country,
			},
		townSlug &&
			relevantPost && {
				path: `/travel/${countrySlug}/${townSlug}`,
				title: relevantPost.town,
			},
	].filter(isNotEmpty);

	return (
		<header className="relative">
			<div className="flex items-center justify-between">
				<div className="my-44">
					<h1 className="font-semibold text-3xl">
						{items[items.length - 1]?.title}
						{/* Add min-height to prevent layout shift between pages */}
						<div className="min-h-[1.5rem]">
							{townSlug && relevantPost && (
								<div className="font-light text-base">
									<span>
										{relevantPost.country}
										{", "}
									</span>
									<time dateTime={relevantPost.date}>
										{format(new Date(relevantPost.date), "MMMM yyyy")}
									</time>
								</div>
							)}
						</div>
					</h1>
					<nav className="mt-2">
						{/* BreadcrumbList schema.org markup: https://schema.org/BreadcrumbList */}
						{/* TODO: Different component for breadcrumb. Or, move all of this into the route component */}
						<ul itemScope itemType="https://schema.org/BreadcrumbList">
							{items.map((item, i) => {
								const isLast = i === items.length - 1;

								return (
									<li
										key={item.path}
										itemProp="itemListElement"
										itemScope
										itemType="https://schema.org/ListItem"
										className={"inline"}
									>
										<Link to={item.path} itemProp="item">
											<span itemProp="name">{item.title}</span>
											<meta itemProp="position" content={String(i + 1)} />
										</Link>
										{!isLast && (
											<ChevronRight
												className="inline-block"
												height={"1.1rem"}
												style={{ marginTop: "-0.1em", strokeWidth: 1.25 }}
											/>
										)}
									</li>
								);
							})}
						</ul>
					</nav>
				</div>
				<div className="world-map" style={{ width: "25rem" }}>
					<WorldMap
						countrySlug={countrySlug}
						style={{ maxWidth: "1000px" }}
						className="mx-auto fill-slate-400"
					/>
				</div>
			</div>
		</header>
	);
}
